import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ExitInterview  {
    _originalTypeClassName = "zERP.BO.ExitInterview";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ExitInterview.translate = translateService;
}
this.InterviewNotes = [];
this.Id = null;
this.InterviewDate = null;
this.State = null;
this.Interview = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
InterviewDate:any;
State:any;
Interview:any;
Account:any;
InterviewFile:any;
EmployeeContract:any;
InterviewNotes:any;
static setAccount = ($this, value) => {
var oldValue = $this.Account;
$this.Account = value;
if (value != null) {
}
}
static setInterviewFile = ($this, value) => {
var oldValue = $this.InterviewFile;
$this.InterviewFile = value;
if (value != null) {
}
}
static setEmployeeContract = ($this, value) => {
var oldValue = $this.EmployeeContract;
$this.EmployeeContract = value;
if (value != null) {
}
}
static setInterviewNotes = ($this, items) => {
                if (items == null) items = [];
                if ($this.InterviewNotes == null) $this.InterviewNotes = [];

                const copyItems = Common.cloneObject(items);

                while ($this.InterviewNotes.length > 0) {
                    Domain.ExitInterview.removeInterviewNotes($this, $this.InterviewNotes[0]);
                }

                Domain.ExitInterview.addManyInterviewNotes($this, copyItems);
            }
static addManyInterviewNotes = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ExitInterview.addInterviewNotes($this, items[i]);
                }
            }
static addInterviewNotes = ($this, item) => {
                if ($this.InterviewNotes == null) $this.InterviewNotes = [];
                if (item == null || $this.InterviewNotes.indexOf(item) > -1) return;
                $this.InterviewNotes.push(item);
if (item.Interview != $this) {
Domain.InterviewNotes.setInterview(item, $this);
}
}
static addRangeInterviewNotes = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ExitInterview.addInterviewNotes($this, item));
            }
static removeInterviewNotes = ($this, item) => {
                if ($this == null || $this.InterviewNotes == null || $this.InterviewNotes.indexOf(item) === -1) return;
                var _index = $this.InterviewNotes.indexOf(item);
                $this.InterviewNotes.splice(_index, 1);
item.Interview = null;
}
static clearInterviewNotes = ($this) => { $this.InterviewNotes = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}